<template>
  <section class="restrictions">
    <vue-headful
      :title="$t('TITLE_TYPE', { type: $tc('RESTRICTION', 2) }) | formatTitle"
    ></vue-headful>
    <restriction-list></restriction-list>

    <router-view class="restrictions__route"></router-view>
  </section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
</style>

<script>
// @flow
import RestrictionList from './RestrictionList'

export default {
  name: 'restrictions',
  components: { RestrictionList }
}
</script>
